import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from 'sweetalert2';
import TablePagination from '@mui/material/TablePagination';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

import { ToastContainer, toast } from "react-toastify";
import {
  add_new_committe_member,
  get_committee_members_data,
  disableCommitteMember,
  deleteCommitteMember,
  updateCommitteTable,
  freeze_members,
  show_committee_names,
  show_sustanaible_goals,
  get_committee_mahila_bal_freeze_data,
} from "../../api/User";
import "../Admin/table.css"
const ManageCommitteMamberDetails = ({ committeName, memberType }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [formData, setFormData] = useState({
    id: userId,
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [formErrors, setFormErrors] = useState({
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [othersInput, setOthersInput] = useState(false);
  const [memberTypeState, setMemberTypeState] = useState(memberType || []);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [MemberTypeErr, setMemberTypeErr] = useState("");
  const [validateFormData, setvalidateFormData] = useState("");
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [isFreezeVisible, setIsFreezeVisible] = useState(false);
  const [isModifyVisible, setIsModifyVisible] = useState(false);
  const [filterModifyData, setFilteredDataModify] = useState([]);
  const [filteredFreezeData, setFilteredDataFreeze] = useState([]);
  const [rows, setRows] = useState([]);
  const [activeButton, setActiveButton] = useState(null);
  const [sustanaibleGoals, setsustanaibleGoals] = useState([]);
  const [committeeNames, setcommitteeNames] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modifyPagerPage] = useState(10);
  const [freezePage, setFreezePage] = useState(0);
  const [modifyRowsPerPage, setModifyRowsPerPage] = useState(10);
  const [freezeRowsPerPage, setFreezeRowsPerPage] = useState(10);
  const [modifyPage, setModifyPage] = useState(0);
  const navigate = useNavigate();
  const fetchDataFreeze = async (ID) => {
    const data = {
      id: userId,
      role_id: role_id,
      gp_data_id: gpID,
      type: "committee",
    };
    try {
      const res = await get_committee_mahila_bal_freeze_data(token, data);
      if (res.status === "success") {
        const freez = res.data.filter((item) => {
          return item.is_active == 1
        })
        setFilteredDataFreeze(freez);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  const fetchData = async () => {
    const data = {
      id: userId,
      role_id: role_id,
      gp_data_id: gpID,
    };
    try {
      const res = await get_committee_members_data(token, data);
      console.log(res);
      if (res.status === "success") {
        const modify = res.data.filter((item) => {
          return item.is_active == 1 && item.is_freeze == 0
        })
        const freez = res.data.filter((item) => {
          return item.is_active == 1
        })
        setFilteredData(res.data);
        setFilteredDataModify(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    handleReset();
    setOthersInput();
    fetchData();
    fetchDataFreeze();
  }, []);
  useEffect(() => {
    const fetchCommitteeNames = async () => {
      try {
        const res = await show_committee_names(token);
        if (res.status === "success") {
          setcommitteeNames(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching committee names:", error);
        toast.error("An error occurred while fetching committee names.", { autoClose: 1000 });
      }
    };
    fetchCommitteeNames();
  }, [token]);
  const fetchcommitteeid = async (committee_id) => {
    try {
      const res = await show_sustanaible_goals(token, committee_id);
      if (res.status === "success") {
        setsustanaibleGoals(res.data);
        return res.data;
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const committeeTypeError = formData.committee_type ? "" : "Committee Name is required.";
    const memberTypeError = formData.member_type ? "" : "Sustainable Goal is required.";
    const newFormErrors = {
      id: formData.id,
      committee_type: committeeTypeError,
      member_type: memberTypeError,
      member_name: "",
      mobile_no: "",
    };
    setFormErrors(newFormErrors);
    if (formData.committee_type && formData.member_type) {
      try {
        const members = tableData.map(item => ({
          id: formData.id,
          member_name: item.member_name,
          mobile_no: item.mobile_no,
          member_type: formData.member_type,
          committee_type: formData.committee_type,
        }));
        if (members.length === 0) {
          toast.error("At least one member is required.");
          return;
        }
        const submissionData = {
          committees: members,
        };
        console.log("Submitting data:", submissionData);
        const res = await add_new_committe_member(token, submissionData);
        if (res.status === "success") {
          toast.success(res.message);
          fetchData();
          handleReset();
          setOthersInput(false);
          setShowTable(false);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred while submitting the form.");
      }
    } else {
      setFormErrors(newFormErrors);
    }
  };
  const handleEditSubmit = async (event) => {
    event.preventDefault();
    const committeeTypeError = editData.committee_name ? "" : "Committee Name is required.";
    const memberTypeError = editData.sub_committee_names ? "" : "Sustainable Goal is required.";
    const memberNameError = editData.member_name ? "" : "Member Name is required.";
    const mobileNoError = validateMobileNo(editData.mobile_no);
    const newErrors = {
      committee_name: committeeTypeError,
      sub_committee_names: memberTypeError,
      member_name: memberNameError,
      mobile_no: mobileNoError
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    if (hasErrors) {
      return;
    }
    const submissionData = {
      id: editData.id,
      member_name: editData.member_name,
      mobile_no: editData.mobile_no,
      member_type: editData.member_type,
      committee_type: editData.committee_type,
    };
    try {
      const res = await updateCommitteTable(token, submissionData);
      if (res.status === "success") {
        toast.success(res.message);
        fetchData();
        setOpenEditModal(false);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.");
    }
  };
  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      if (numericValue.startsWith("0")) {
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: "Mobile number cannot start with 0.",
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateMobileNo(numericValue),
        }));
      }
    }
    else if (name === "member_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      const trimmedValue = cleanedValue.replace(/^\s+/, '');
      setFormData((prevState) => ({
        ...prevState,
        [name]: trimmedValue,
      }));
      if (!trimmedValue.trim()) {
        setFormErrors((prevState) => ({
          ...prevState,
          member_name: "Member Name is required.",
        }));
      } else {
        setFormErrors((prevState) => ({
          ...prevState,
          member_name: "",
        }));
      }
    }
    else if (name === "member_type") {
      const selectedId = value;
      setFormData((prevState) => ({
        ...prevState,
        [name]: selectedId,
      }));
      const selectedItem = sustanaibleGoals.find((goal) => goal.id === parseInt(selectedId));
      if (selectedItem) {
        setFormData((prevState) => ({
          ...prevState,
          member_type_display: selectedItem.sub_committee_names,
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          member_type: "",
        }));
      } else {
        setFormErrors((prevState) => ({
          ...prevState,
          member_type: "Sustainable Goal is required.",
        }));
      }
    }
    else if (name === "committee_type") {
      const selectedId = value;
      const selectedCommittee = committeeNames.find(
        (committee) => String(committee.committee_id) === String(selectedId)
      );
      fetchcommitteeid(selectedId);
      const committeeName = selectedCommittee ? selectedCommittee.committee_name : "";
      setFormData((prevState) => ({
        ...prevState,
        [name]: selectedId,
        committee_type_name: committeeName,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        committee_type: "",
      }));
      setOthersInput(selectedId === "Any other Committee");
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleEdit = async (ID) => {
    const selectedData = filteredData.find(item => item.id === ID);
    if (selectedData) {
      const committeeMatch = committeeNames.find(committee =>
        committee.committee_name === selectedData.committee_name
      );
      if (committeeMatch) {
        const fetchedGoals = await fetchcommitteeid(committeeMatch.committee_id);
        const matchingGoals = fetchedGoals.filter(goal =>
          goal.sub_committee_names === selectedData.sub_committee_names &&
          (goal.committee_id === committeeMatch.committee_id)
        );
        const goalMatch = matchingGoals.length > 0 ? matchingGoals[0] : null;
        setEditData({
          ...selectedData,
          committee_type: committeeMatch ? committeeMatch.committee_id : "Any other Committee",
          member_type: goalMatch ? goalMatch.id : "",
        });
      }
      setOthersInput(!committeeMatch);
      setOpenEditModal(true);
    } else {
      console.error("Data with the given ID not found");
    }
  };
  const handleEditChange = (event) => {
    const { name, value } = event.target;

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setEditData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "member_name"){
      // Convert to uppercase and clean the input
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      const trimmedValue = cleanedValue.trimStart(); // Trim leading spaces
  
      // Update state
      setEditData((prevState) => ({
        ...prevState,
        [name]: trimmedValue,
      }));
  
      // Validation logic
      if (trimmedValue.length === 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          member_name: "Member Name is required"
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          member_name: null // Clear the error if input is valid
        }));
      }
    }  else if (name === "member_type") {
      const selectedId = value;
      setEditData((prevState) => ({
        ...prevState,
        [name]: selectedId,
      }));
      const selectedItem = sustanaibleGoals.find((goal) => goal.id === parseInt(selectedId));
      if (selectedItem) {
        setEditData((prevState) => ({
          ...prevState,
          member_type_display: selectedItem.sub_committee_names,
        }));
      }
    } else if (name === "committee_type") {
      const selectedId = value;
      const selectedCommittee = committeeNames.find((committee) => String(committee.committee_id) === String(selectedId));
      fetchcommitteeid(selectedId);
      const committeeName = selectedCommittee ? selectedCommittee.committee_name : "";
      setEditData((prevState) => ({
        ...prevState,
        [name]: selectedId,
        committee_type_name: committeeName,
      }));
      setOthersInput(selectedId === "Any other Committee");
    } else {
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleDisableButton = async (is_active, ID) => {
    const newIsActive = is_active === 1 ? 0 : is_active;
    const data = {
      id: ID
    };
    try {
      const res = await disableCommitteMember(token, data);
      if (res.status === "success") {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === ID ? { ...row, is_active: newIsActive } : row
          )
        );
        toast.success("Deactivate successfully", { autoClose: 1000 });
        fetchData();
      } else {
        toast.error("An error occurred while updating the item.", { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", { autoClose: 1000 });
    }
  };
  const handleReset = () => {
    setFormData({
      id: userId,
      committee_type: "",
      committeName: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
    setFormErrors({
      committee_type: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
  };
  const handleDelete = (ID) => {
    const selectedRecord = filteredData.find(record => record.id === ID);
    if (!selectedRecord) {
      console.error('Record not found');
      return;
    }
    setDeleteIndex(ID);
    Swal.fire({
      title: 'Confirm Delete',
      text: 'Are you sure you want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleConfirmDelete(ID);
      }
    });
  };
  const handleConfirmDelete = async (idToDelete) => {
    try {
      await deleteCommitteMember(token, idToDelete);
      const updatedData = filteredData.filter(record => record.id !== idToDelete);
      setFilteredData(updatedData);
      toast.success("Deleted successfully", { autoClose: 1000 });
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
    }
  };
  const handleToggleActive = async (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, is_active: row.is_active === 1 ? 0 : 1 } : row
    );
    setFilteredData(updatedData);
    try {
      const res = await disableCommitteMember(token, { id: filteredData[index].id, is_active: updatedData[index].is_active });
      if (res.status === "success") {
        toast.success("Updated successfully");
      } else {
        toast.error("An error occurred while updating the item.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the item.");
    }
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
  };
  const handleConfirmFreeze = async (is_freeze, ID) => {
    const actionText = is_freeze === 1 ? "unfreeze" : "freeze";
    const result = await Swal.fire({
      title: 'Confirm Action',
      text: `Are you sure you want to ${actionText} this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: 'Cancel',
    });
    if (result.isConfirmed) {
      const newIsFreeze = is_freeze === 1 ? 0 : 1;
      const data = {
        id: ID,
        type: "committee",
        role_id: role_id,
      };
      try {
        const res = await freeze_members(token, data);
        if (res.status === "success") {
          const updatedRow = { ...rows.find(row => row.id === ID), is_freeze: newIsFreeze };
          setRows(prevRows =>
            prevRows.map(row =>
              row.id === ID ? updatedRow : row
            )
          );
          toast.success("Data freezed successfully", { autoClose: 1000 });
          fetchDataFreeze(ID);
          fetchData();
        } else {
          toast.error("An error occurred while updating the item.", { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error during freeze operation:", error);
        toast.error("An error occurred. Please try again.", { autoClose: 1000 });
      }
    }
  };
  const handleComitteeChange = (e) => {
    console.log(e.target.value);
    formData.committee_type = e.target.value
  };
  const handleView = () => {
    setIsTableVisible(true);
    setIsModifyVisible(false);
    setIsFreezeVisible(false);
  };
  const handleModify = () => {
    setIsTableVisible(false);
    setIsFreezeVisible(false);
    setIsModifyVisible(true);
  };
  const handleFreeze = () => {
    setIsFreezeVisible(true);
    setIsTableVisible(false);
    setIsModifyVisible(false);
  };
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleFreezePageChange = (event, newPage) => {
    setFreezePage(newPage);
  };
  const paginatedModifyData = filterModifyData.slice(
    modifyPage * modifyRowsPerPage,
    modifyPage * modifyRowsPerPage + modifyRowsPerPage
  );
  const handleModifyPageChange = (event, newPage) => {
    setModifyPage(newPage);
  };
  const handleModifyRowsPerPageChange = (event) => {
    setModifyRowsPerPage(parseInt(event.target.value, 10));
    setModifyPage(0);
  };
  const handleFreezeRowsPerPageChange = (event) => {
    setFreezeRowsPerPage(parseInt(event.target.value, 10));
    setFreezePage(0);
  };
  const paginatedFreezeData = filteredFreezeData.slice(
    freezePage * freezeRowsPerPage,
    freezePage * freezeRowsPerPage + freezeRowsPerPage
  );
  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>
      <div className="ms-2" style={{ height: "90vh" }}>
        <div style={{ backgroundColor: '#FFFFFF', padding: '16px', marginTop: "-17px", }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
          Committee Members Details
          </h2> 
        </div>
        <div className="d-flex justify-content-end">
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              onClick={() => {
                handleView();
                handleButtonClick('view');
              }}
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'view' ? "#5E63C7" : "#4763E430", // Active color when inactive
                color: activeButton === 'view' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isTableVisible ? 'View' : 'View'}
            </Button>

          </div>
          <div className="col-md-2 row mt-2">
            <Button
              onClick={() => {
                handleModify();
                handleButtonClick('modify');
              }}
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'modify' ? "#5E63C7" : "#4763E430", // Inactive color when active
                color: activeButton === 'modify' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isModifyVisible ? 'Modify' : 'Modify'}
            </Button>

          </div>
          <div className="col-md-2 row mt-2">
            <Button
              onClick={() => {
                handleFreeze();
                handleButtonClick('freeze');
              }}
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'freeze' ? "#5E63C7" : "#4763E430", // Inactive color when active
                color: activeButton === 'freeze' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isFreezeVisible ? 'Freeze' : 'Freeze'}
            </Button>

          </div>
        </div>
        <div>
          {isTableVisible && (
            <div>
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>View Resources</h4>
              <hr style={{ margin: '20px 0', zIndex : -1000 }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px' }}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: -1000,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                   <TableRow>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SR NO.
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    COMMITTEES NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SUSTAINABLE GOAL
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MEMBER NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MOBILE NUMBER
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    STATUS
                  </TableCell>
                </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? '#ffcccc' : 'none',
                          }}
                        >
                         <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.committee_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.sub_committee_names}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.member_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                        {row.mobile_no}
                      </TableCell>                          <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {row.is_freeze == 0 ? (
                                <Tooltip title="Unfreezed" arrow>
                                  <span
                                    variant="contained"
                                    color="secondary"
                                    style={{
                                      width: '100px',
                                      height: '40px',
                                      marginRight: '8px',
                                      color: 'purple',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    UNFREEZED
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Freezed" arrow>
                                  <span
                                    variant="contained"
                                    color="primary"
                                    style={{
                                      width: '100px',
                                      height: '40px',
                                      color: "blue",
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    FREEZED
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={10} style={{ textAlign: 'center', fontWeight: 'bold' }}>Data Not Found</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />
            </div>
          )}
        </div>
        <div>
          {isModifyVisible && (
            <div >
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>Modify Resources</h4>
              <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px', zIndex: -1000}}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: -1000,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                   <TableRow>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SR NO.
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    COMMITTEES NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SUSTAINABLE GOAL
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MEMBER NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MOBILE NUMBER
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    ACTION
                  </TableCell>
                </TableRow>                  </TableHead>
                  <TableBody>
                    {filterModifyData.length > 0 ? (
                      paginatedModifyData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? "#ffcccc" : "none",
                          }}
                        >
                           <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.committee_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.sub_committee_names}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.member_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                        {row.mobile_no}
                      </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip title="Edit" arrow>
                                <Button
                                  onClick={() => handleEdit(row.id)}
                                  size="small"
                                  sx={{ color: "blue", minWidth: "auto", marginRight: "5px" }}
                                >
                                  <EditIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Delete" arrow>
                                <Button
                                  onClick={() => handleDelete(row.id)}
                                  size="small"
                                  sx={{ color: "red", minWidth: "auto" }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                              <tr
                                key={row.id}
                                style={{ backgroundColor: row.is_active === 0 ? "transparent" : "transparent" }}
                              >
                                <td>
                                  <Tooltip title={row.is_active ? "Deactivate" : "Activate"} arrow>
                                    <Switch
                                      disabled={row.is_active === 0}
                                      checked={row.is_active === 1}
                                      onChange={() => handleDisableButton(row.is_active, row.id)}
                                      color="default"
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "green",
                                        },
                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                          backgroundColor: "green",
                                        },
                                        "& .MuiSwitch-track": {
                                          backgroundColor: "red",
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                </td>
                              </tr>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={10} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          Data Not Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filterModifyData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleModifyPageChange} onRowsPerPageChange={handleModifyRowsPerPageChange} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />

              </div>
            </div>
          )}
        </div>
        <div>
          {isFreezeVisible && (
            <div >
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>Freeze Resources</h4>
              <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px', zIndex: -1000}}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: -1000,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                     <TableRow>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SR NO.
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    COMMITTEES NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    SUSTAINABLE GOAL
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MEMBER NAME
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    MOBILE NUMBER
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                    STATUS
                  </TableCell>
                </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredFreezeData.length > 0 ? (
                      paginatedFreezeData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? '#ffcccc' : 'none',
                          }}
                        >
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.committee_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.sub_committee_names}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                        {row.member_name}
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", textAlign: "center" }} className="custom-class">
                        {row.mobile_no}
                      </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <Tooltip title={row.is_active === 1 ? 'Unfreeze' : 'Freeze'} arrow>
                                <Button
                                  variant="contained"
                                  color={row.is_active === 1 ? 'secondary' : 'primary'}
                                  onClick={() => handleConfirmFreeze(row.is_freeze, row.id, index)}
                                  style={{
                                    width: '100px',
                                    height: '40px',
                                    marginRight: '8px',
                                  }}
                                >
                                  Freeze
                                </Button>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={10} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          Data Not Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filteredFreezeData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleFreezePageChange} onRowsPerPageChange={handleFreezeRowsPerPageChange} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />

              </div>
            </div>
          )}
        </div>
        <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle style={{ fontWeight: "bold" }}>
          <div style={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>
            Edit Record
          </div>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenEditModal(false)}
            aria-label="close"
            style={{ position: "absolute", right: 15, top: 7 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleEditSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="editCommitteeType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Committees Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.committee_type ? "is-invalid" : ""}`}
                  name="committee_type"
                  id="editCommitteeType"
                  value={editData?.committee_type || ""}
                  onChange={handleEditChange}
                  disabled={editData?.is_active === 0}
                >
                  <option value="" disabled>Select Committee Name</option>
                  {committeeNames.map((committee) => (
                    <option key={committee.committee_id} value={committee.committee_id}>
                      {committee.committee_name}
                    </option>
                  ))}
                </select>
                {errors.committee_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem", fontWeight: "800" }}>
                    {errors.committee_type}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label htmlFor="editMemberType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Sustainable Goal <span style={{ color: "red", fontWeight: "800" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.sub_committee_names ? "is-invalid" : ""}`}
                  name="member_type"
                  id="editMemberType"
                  value={editData?.member_type || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    console.log('')

                    handleEditChange({
                      target: {
                        name: "member_type",
                        value: selectedId,
                      },
                    });
                    const selectedItem = sustanaibleGoals.find((goal) => goal.id === parseInt(selectedId));
                    if (selectedItem) {
                      handleEditChange({
                        target: {
                          name: "sub_committee_names",
                          value: selectedItem.sub_committee_names,
                        },
                      });
                    }
                  }}
                  disabled={editData?.is_active === 0}
                >
                  <option value="" >Select Sustainable Goal</option>
                  {sustanaibleGoals?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.sub_committee_names}
                    </option>
                  ))}
                </select>
                {formErrors.member_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.member_type}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="editMemberName"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Member Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.member_name ? "is-invalid" : ""}`}
                  name="member_name"
                  id="editMemberName"
                  value={editData?.member_name || ""}
                  
                  placeholder="Enter the Member Name"
                  disabled={editData?.is_active == 0}
                  onChange={handleEditChange}
                />
                {errors.member_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.member_name}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="editMobileNo"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                  name="mobile_no"
                  id="editMobileNo"
                  value={editData?.mobile_no || ""}
                  onChange={handleEditChange}
                  placeholder="Enter the Mobile No"
                  disabled={editData?.is_active == 0}
                />
                {errors.mobile_no && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.mobile_no}
                  </p>
                )}
              </div>
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={() => setOpenEditModal(false)}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#3235B6",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  style={{
                    backgroundColor: "#3235B6",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>
          <AlertIcon style={{ color: "red", marginRight: "8px" }} />
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this record?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button color="secondary" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
        <ToastContainer />
      </div>
    </>
  );
};
export default ManageCommitteMamberDetails;
